function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-sf .a{fill:#00abe8;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-504.657 1410.495) rotate(-135)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(625.927 1354.825)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 0.929,
  height: 6.995,
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 0.929,
  height: 6.995,
  transform: "translate(0 6.995) rotate(-90)"
})), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 1.038,
  height: 15.082,
  transform: "translate(636.668 1350.36) rotate(45)"
}));

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow-sf",
    width: 15.699,
    height: 9.893,
    viewBox: "0 0 15.699 9.893",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.5b96195c.svg";
export { ForwardRef as ReactComponent };